import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async updateOrderAddress({ commit, rootGetters: { getOrder } }, payload) {
    try {
      const { data } = await request.put(
        `orders/${getOrder.uuid}/addresses`,
        payload,
      );

      if (data.error) {
        throw Error('Server-side validation failed');
      }

      await commit('updateOrderAddress', payload);
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
